import { ROOT_ID } from './const.ts'

export type OdsClientWindowProps = {
  baseUrl: string
  rootId: string
}

export const loadVariablesToWindow = (baseUrl: string): void => {
  globalThis._odsClient ??= []
  globalThis._odsClient.push({
    baseUrl,
    rootId: ROOT_ID,
  })
}
